module.exports = __webpack_public_path__ + "img/14.5.COD.9d97e8de.png";